import { Link } from 'gatsby';
import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';

import { dateRangeMed } from '../../helpers/dates';
import { OccationEventCard } from '../../helpers/list-page/interfaces/list-card.interface';
import { ILibraryMeetingPlaceDictionary } from '../../queries/fragments/libraryMeetingPlaceDictionary';
import ImageWrapper from '../image-wrapper/Image-wrapper';

interface CardEventProps {
  card: OccationEventCard;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
}

export const CardEvent = ({ card, cardIndex, dictionary }: CardEventProps) => {
  return (
    <Link
      to={card?.slug}
      key={card?.id}
      className={`group flex animate-fadeIn cursor-pointer flex-col overflow-hidden rounded-xl  opacity-0 focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light animation-delay-${cardIndex} bg-background-primary-light transition-all hover:bg-background-secondary`}
    >
      {card?.image && (
        <div
          className="image-box rounded-xl bg-background-primary-light transition-all hover:bg-background-secondary"
          style={{
            backgroundImage: `url(${card?.image?.file.url})`,
          }}
        ></div>
      )}

      <div className="flex min-h-[120px] flex-1 flex-col flex-wrap rounded-b-xl bg-background-primary-light px-6 py-5 transition-all duration-200 group-hover:bg-background-secondary">
        <div className="mb-auto">
          <div className="mb-1 text-bodym font-bold text-text-light">
            {dateRangeMed(
              card?.startDate.toString(),
              card?.endDate.toString(),
              card?.node_locale,
            )}
          </div>

          <h2
            className={`mb-4 line-clamp-2 h-[42px] overflow-hidden text-ellipsis font-title text-headings text-text-default transition-all duration-200 ease-in-out
          `}
          >
            {card?.name}
          </h2>
          <div className="">
            {card?.endDate && card?.endDate < DateTime.now() && (
              <span className="inline-block rounded-[7px] border-2 border-brand-red-2 bg-brand-red-1 px-2 text-bodyxs font-bold text-text-sticker-red">
                {dictionary?.pastEvent}
              </span>
            )}
            {card?.eventTypes &&
              card?.endDate &&
              card?.endDate > DateTime.now() &&
              card?.eventTypes?.map((eventType, key) => (
                <span
                  key={key}
                  className="mb-1 mr-2 mt-auto inline-block rounded-[7px] border-2 border-neutral-grey-300 bg-background-primary-light px-2 text-bodyxs font-bold text-text-default last:border-brand-green-2 last:bg-brand-green-1 last:text-text-sticker-green"
                >
                  {eventType.name}
                </span>
              ))}
          </div>
        </div>
      </div>
    </Link>
  );
};
